export default "__VITE_ASSET__DkYOOpgb__"